import { render, staticRenderFns } from "./SiteMap.vue?vue&type=template&id=b21e5240"
import script from "./SiteMap.vue?vue&type=script&lang=js"
export * from "./SiteMap.vue?vue&type=script&lang=js"
import style0 from "./SiteMap.vue?vue&type=style&index=0&id=b21e5240&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b21e5240')) {
      api.createRecord('b21e5240', component.options)
    } else {
      api.reload('b21e5240', component.options)
    }
    module.hot.accept("./SiteMap.vue?vue&type=template&id=b21e5240", function () {
      api.rerender('b21e5240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Components/Header/SiteMap.vue"
export default component.exports